const quizScore = {
  feedback: 'Very Very Good Job',
  score: '55.2%',
  points: '37',
  totalPoints: '67',
};

export default quizScore;
